<template>
  <el-dialog
    top="15vh"
    class="device-command-edit__dialog"
    title="指令下发"
    width="900px"
    :close-on-click-modal="false"
    :before-close="close"
    :visible.sync="visible"
  >
    <div class="padding">
      <Alert :showIcon="false" class="mqtt">
        EMQ服务器状态：<span :class="mqttConnectState">{{ mqttStateName }}</span>
      </Alert>
      <div class="device">
        <h3>{{ row.name | format }}</h3>
        <span>(通讯编码 {{ row.communicationCode | format }})</span>
      </div>
      <el-row :gutter="24" class="cmd">
        <el-col :span="6" v-for="(item, index) in cmdList" :key="index">
          <div
            class="cmd-item"
            :class="{ active: selectCmdIndex === index }"
            @click="handleCmdClick(item, index)"
          >
            {{ item.name }}
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="divider"></div>
    <div class="padding">
      <div class="form">
        <el-form
          ref="form"
          :rules="rules"
          :model="form"
          label-width="140px"
          size="small"
          label-suffix=": "
          v-if="selectedCmd.inputData && selectedCmd.inputData.length > 0"
        >
          <template v-for="(item, index) in selectedCmd.inputData">
            <CommondFormItem :key="index" :item="item" v-model="form" />
            <!-- <template v-if="item.dataType === 'struct'">
              <div :key="index">
                <CommondFormItem
                  v-for="(jsonItem, jsonIndex) in item.specs.item"
                  :key="jsonIndex"
                  :item="jsonItem"
                  v-model="form"
                />
              </div>
            </template>
            <template v-else>
              <CommondFormItem :key="index" :item="item" v-model="form" />
            </template> -->
          </template>
        </el-form>
      </div>
      <div class="data">
        <div class="data-item">
          <div class="label">下发指令</div>
          <div class="empty" v-if="downMessage === null">暂无数据</div>
          <div class="json" v-else>
            <code>
              <pre>{{ downMessage }}</pre>
            </code>
          </div>
        </div>
        <div class="data-item">
          <div class="label">设备回复消息</div>
          <div class="empty" v-if="receiveMessagList.length <= 0">暂无数据</div>
          <div class="json" v-else>
            <code>
              <pre v-for="(code, index) in receiveMessagList" :key="index">{{ code }}</pre>
            </code>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="edit-footer">
      <hl-button type="border" @click="close">取消</hl-button>
      <hl-button
        @click="downCmd"
        :loading="loading"
        :disabled="mqttConnectState !== mqttState.success || selectCmdIndex === ''"
      >
        下发指令
      </hl-button>
    </div>
  </el-dialog>
</template>

<script>
let client = null
let timer = null
import Alert from '@/components/Alert'
import CommondFormItem from './CommondFormItem'
import { format } from '@/utils/utils'
import { createMqttClient, topicPrefix } from '@/utils/mqttClient'
const mqttState = {
  loading: 'loading',
  fail: 'fail',
  success: 'success'
}
const mqttStateNameEnum = {
  loading: '连接中...',
  fail: '连接失败',
  success: '已连接'
}
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    row: Object
  },
  components: {
    Alert,
    CommondFormItem
  },
  data() {
    return {
      mqttState,
      mqttConnectState: mqttState.loading,
      form: {},
      rules: {},
      loading: false,
      downTopic: `${topicPrefix}gateway/${this.row.gatewayCommunicationCode}/down`,
      upTopic: `${topicPrefix}gateway/${this.row.gatewayCommunicationCode}/up`,
      cmdList: [],
      selectedCmd: {},
      selectCmdIndex: '',
      downMessage: null,
      receiveMessagList: []
    }
  },
  created() {
    this.connectMqttService()
    this.queryCmd()
    this.$emit('refresh')
  },
  computed: {
    mqttStateName() {
      return mqttStateNameEnum[this.mqttConnectState]
    }
  },
  filters: {
    format
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
    },
    isNumberType(dataType) {
      return ['int', 'float', 'double'].indexOf(dataType) > -1
    },
    isArrayType(dataType) {
      return ['array'].indexOf(dataType) > -1
    },
    connectMqttService() {
      client = createMqttClient(this, onMessage(this), onConnect(this), onError(this))
    },
    queryCmd() {
      let params = {
        productKey: this.row.productKey
      }
      this.$ajax.get(this.$api.device.device_cmd_list, params).then((res) => {
        this.cmdList = res.data
      })
    },
    // 指令项点击的事件处理函数
    handleCmdClick(item, index) {
      if (this.mqttConnectState !== mqttState.success) return
      this.selectedCmd = item
      this.selectCmdIndex = index
      const inputData = item.inputData
      const form = {
        directoryNum: this.row.directoryNum,
        user: this.row.user
      }
      inputData.forEach((item) => {
        if (item.dataType === 'array') {
          form[item.identifier] = [undefined]
        } else {
          form[item.identifier] = undefined
        }
      })
      this.form = form
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    checkForm() {
      let pass
      this.$refs.form.validate((valid) => {
        pass = valid
      })
      return pass
    },
    downCmd() {
      console.log(111)
      if (!this.checkForm()) return
      console.log(this.form)
      let cmd = {
        cmd: this.selectedCmd.identifier,
        child: this.row.communicationCode,
        params: {
          ...this.form
        }
      }
      const inputData = this.selectedCmd.inputData
      for (let i = 0; i < inputData.length; i++) {
        if (this.isNumberType(inputData[i].dataType)) {
          cmd.params[inputData[i].identifier] = Number(cmd.params[inputData[i].identifier])
        }
        if (this.isArrayType(inputData[i].dataType)) {
          cmd.params[inputData[i].identifier] = cmd.params[inputData[i].identifier].filter(Boolean)
        }
        if (inputData[i].dataType === 'enum' && inputData[i].specs.type === 'int') {
          cmd.params[inputData[i].identifier] = Number(cmd.params[inputData[i].identifier])
        }
      }
      this.downMessage = cmd

      client.publish(this.downTopic, JSON.stringify(cmd))
      client.subscribe(this.upTopic)
      this.loading = true
      timer = setTimeout(() => {
        this.loading = false
        this.$message.error('60秒内未收到设备回复')
        client.unsubscribe(this.upTopic)
        this.receiveMessagList.push('下发失败')
      }, 60000)
    }
  }
}
function onConnect(self) {
  return function() {
    self.mqttConnectState = mqttState.success
  }
}
function onError(self) {
  return function() {
    self.mqttConnectState = mqttState.fail
  }
}
function onMessage(self) {
  return function(topic, message) {
    let payload
    try {
      payload = JSON.parse(message.toString(), null, 2)
    } catch (err) {
      /* eslint-disable-next-line */
      payload = {}
    }
    if (payload.cmd === self.selectedCmd.identifier) {
      self.receiveMessagList.push(payload)
      client.unsubscribe(self.upTopic)
      timer && clearTimeout(timer)
      self.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.device-command-edit__dialog {
  /deep/.el-dialog__body {
    padding: 0;
  }
}
.padding {
  padding: 24px;
}
.mqtt {
  margin-bottom: 24px;
  color: #333;
  span {
    &.success {
      color: $--color-cyanblue;
    }
    &.loading {
      color: $--color-blue;
    }
    &.fail {
      color: $--color-red;
    }
  }
}
.device {
  margin-bottom: 24px;
  display: flex;
  align-items: flex-end;
  h3 {
    font-size: 24px;
    color: #333333;
  }
  span {
    margin-left: 10px;
    font-size: 16px;
    color: #999999;
  }
}
.cmd-item {
  border: 1px solid rgba(220, 220, 220, 1);
  border-radius: 6px;
  padding: 6px 0;
  height: 32px;
  text-align: center;
  font-size: 14px;
  color: #231815;
  cursor: pointer;
  &.active {
    position: relative;
    color: $--color-blue;
    border: 2px solid $--color-blue;
    &::after {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      right: 0;
      background: url('../../../assets/select_hook.svg') no-repeat right bottom / 20px 20px;
    }
  }
}
.divider {
  height: 24px;
  background: #d8d8d8;
  background: linear-gradient(rgba(151, 151, 151, 0.1), #ffffff);
  border-top: 1px solid rgba(151, 151, 151, 0.1);
}
.data {
  display: flex;
  justify-content: space-between;
}
.data-item {
  flex: 1;
  padding: 16px;
  min-height: 245px;
  background: #f5f8fc;
  border-radius: 8px;
  & + .data-item {
    margin-left: 24px;
  }
  .label {
    font-size: 16px;
    color: #333333;
    font-weight: 600;
    margin-bottom: 16px;
  }
  .empty {
    font-size: 14px;
    color: #999999;
    font-weight: 400;
  }
  .json {
    font-size: 14px;
    color: #333333;
    font-weight: 400;
    pre {
      line-height: 22px;
    }
  }
}
</style>
